import cn from 'classnames';

import { MdKeyboardArrowDown, MdKeyboardArrowLeft, MdKeyboardArrowRight, MdKeyboardArrowUp } from 'react-icons/md';

import VideoBox from '@src/components/VideoBox';

import { useVideoSidebar } from './useVideoSidebar';

import { IVideoStream } from '@src/types';

import './VideosContainerScreen.scss';

interface VideosSidebarProps {
  videos: IVideoStream[];
  isVertical?: boolean;
}

const VideosSidebar = ({ videos, isVertical }: VideosSidebarProps) => {
  const {
    containerRef,
    handleUp,
    handleDown,
    visibleVideos,
    startIndex,
    visibleCount,
    ITEM_HEIGHT,
    ITEM_HORIZONTAL_WIDTH,
  } = useVideoSidebar({
    videos,
    isVertical,
  });

  if (!visibleVideos.length) return null;

  return (
    <div
      className={cn('video-sidebar', {
        'vertical-bar-layout': isVertical,
        'horizontal-bar-layout': !isVertical,
      })}
    >
      {startIndex > 0 && (
        <button onClick={handleUp} className="arrow-button arrow-top">
          {isVertical ? <MdKeyboardArrowUp /> : <MdKeyboardArrowLeft />}
        </button>
      )}
      <div className="content" ref={containerRef}>
        {visibleVideos.map((video, index) => (
          <div
            key={`${video.peerId}-${video.type}`}
            style={
              isVertical
                ? { minHeight: `${ITEM_HEIGHT}px` }
                : {
                    minWidth: ITEM_HORIZONTAL_WIDTH,
                    maxWidth: 350,
                    height: 158,
                  }
            }
            className="video-box-container"
          >
            <VideoBox
              {...video}
              style={{ height: '100%', flex: 1, width: isVertical ? '272px' : '100%', maxWidth: '100%' }}
            />
          </div>
        ))}
      </div>
      {startIndex + visibleCount < videos.length && (
        <button onClick={handleDown} className="arrow-button arrow-bottom">
          {isVertical ? <MdKeyboardArrowDown /> : <MdKeyboardArrowRight />}
        </button>
      )}
    </div>
  );
};

export default VideosSidebar;
